import { render, staticRenderFns } from "./asset-type-form.vue?vue&type=template&id=bb40ec3c&scoped=true&"
import script from "./asset-type-form.vue?vue&type=script&lang=js&"
export * from "./asset-type-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb40ec3c",
  null
  
)

export default component.exports